export const FILTER_EDITOR_LOCALE_ZHCHT = {
    // åæ¶
    cancelButton: 'åæ¶',
    // ç¢ºå®
    okButton: 'ç¢ºå®',
    // æ·»å å­å¥
    addWhere: 'æ·»å å­å¥',
    clear: 'æ¸ç©º',
    // ç½®é 
    moveTop: 'ç½®é ',
    // ä¸ç§»
    moveUp: 'ä¸ç§»',
    // ä¸ç§»
    moveDown: 'ä¸ç§»',
    // ç½®åº
    moveBottom: 'ç½®åº',
    // å·¦æ¬è
    leftBrackets: 'å·¦æ¬è',
    // å­æ®µ
    field: 'å­æ®µ',
    // æä½ç¬¦
    operator: 'æä½ç¬¦',
    // å¼
    value: 'å¼',
    // å¼é¡å
    valueType: 'å¼é¡å',
    expressType: {
        value: 'å¼',
        express: 'é¶éå¼',
        frontExpress: 'è¡¨å®è¡¨éå¼'
    },
    // å³æ¬è
    rightBrackets: 'å³æ¬è',
    // éä¿
    relation: 'éä¿',
    relationValue: {
        and: 'ä¸¦ä¸',
        or: 'æè'
    },
    designTab: 'è¨­è¨å¨',
    jsonTab: 'æºä»£ç¢¼',
    sqlTab: 'Sqlé è¦½',
    title: 'æ¢ä»¶ç·¨è¼¯å¨',
    message: 'ç¢ºèªè¦æ¸ç©ºç¶åæææ¸æåï¼',
    validate: {
        bracket: 'å·¦å³æ¬èä¸å¹éï¼è«æª¢æ¥',
        relation: 'æ¢ä»¶éç³»ä¸å®æ´ï¼è«æª¢æ¥',
        field: 'æ¢ä»¶å­æ®µæªè¨­ç½®ï¼è«æª¢æ¥'
    }
};

export const ENUM_EDITOR_LOCALE_ZHCHT = {
    // åæ¶
    cancelButton: 'åæ¶',
    // ç¢ºå®
    okButton: 'ç¢ºå®',
    // æ·»å å­å¥
    addWhere: 'æ·»å ',
    clear: 'æ¸ç©º',
    // ç½®é 
    moveTop: 'ç½®é ',
    // ä¸ç§»
    moveUp: 'ä¸ç§»',
    // ä¸ç§»
    moveDown: 'ä¸ç§»',
    // ç½®åº
    moveBottom: 'ç½®åº',
    remove: 'åªé¤',

    title: 'æèæ¸æç·¨è¼¯å¨',
    message: 'ç¢ºèªè¦æ¸ç©ºç¶åæææ¸æåï¼',
    value: 'å¼',
    name: 'åç¨±'
};

